import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
	    { path: '/', component: require(page+'home.vue').default },

      // Productos
      { path: '/productos', component: require(page+'products/index.vue').default, meta:{title:"Productos"}},
      { path: '/productos/categoria/:id', component: require(page+'products/subproduct.vue').default, meta:{title:"Producto"}},
  	  { path: '/detalle/producto/:id', component: require(page+'products/description.vue').default, meta:{title:"Producto"}},

      // Proyectos
      { path: '/proyectos', component: require(page+'projects/index.vue').default, meta:{title:"Proyectos"}},
      { path: '/proyectos/categoria/:id', component: require(page+'projects/subproject.vue').default, meta:{title:"Proyecto"}},
  	  { path: '/detalle/proyecto/:id', component: require(page+'projects/description.vue').default, meta:{title:"Proyecto"}},

      // Articulos
      { path: '/articles', component: require(page+'articles/index.vue').default, meta:{title:"Articulos"}},
  	  { path: '/articles/:id', component: require(page+'articles/detail.vue').default, meta:{title:"Articulo"}},

      { path: '/contacto', component: require(page+'contact/index.vue').default, meta:{title:"Contacto"}},
      { path: '/galeria', component: require(page+'galeria/index.vue').default, meta:{title:"Galería"}},
      { path: '/garantias', component: require(page+'guarantees/index.vue').default, meta:{title:"Garantías"}},
      { path: '/empresa', component: require(page+'about-us/index.vue').default, meta:{title:"Empresa"}},
      // { path: '/testimonios', component: require(page+'testimonials/index.vue'), meta:{title:"Testimonios"}},
      { path: '/distribuidores', component: require(page+'dealers/index.vue').default, meta:{title:"Distribuidores"}},
      // { path: '/proveedores', component: require(page+'suppliers/index.vue'), meta:{title:"Proveedores"}},
      { path: '/downloads', component: require(page+'downloads/index.vue').default, meta:{title:"Downloads"}},
  	  { path: '/privacy-policy', component: require(page+'text-pages/aviso.vue').default, meta:{title:"Aviso de Privacidad"}},
  	  // { path: '/cotizador', component: require(page+'cotizador/index.vue'), meta:{title:"Cotizador"}},
      // { path: '/certificados', component: require(page+'certificados.vue'), meta:{title:"Certificados"}},

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "ESLOWINDOWS", filter: (title)=>{ return title+" - ESLOWINDOWS"; } }
);

// export {routes};
export default MyRouter;
